import { BrowserRouter as Router } from 'react-router-dom'
import { createRoot } from 'react-dom/client';
import App from '@/App'

import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { MidmarkTheme } from '@midmark-enterprise/shared-components'
import { QueryClient, QueryClientProvider } from 'react-query'
import { UserVerificationServiceContext } from './services/UserVerificationService'
import { UserVerificationServiceApi } from './services/Implementations/UserVerificationServiceApi'

const queryClient = new QueryClient()
const userVerificationApiService = new UserVerificationServiceApi()

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

root.render(
    <>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={MidmarkTheme}>
                <QueryClientProvider client={queryClient}>
                    <UserVerificationServiceContext.Provider
                        value={userVerificationApiService}
                    >
                        <Router>
                            <App />
                        </Router>
                    </UserVerificationServiceContext.Provider>
                </QueryClientProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    </>
)
